import { getAccountFromStore } from "src/utils/account";
import { Account } from "Types/api/Account";

export const getRegion = (account?: Account): string => {
    if (!account) {
        account = getAccountFromStore();
    }
    return account && account.address ? (account.address.country ? account.address.country : "US") : "US";
};

export const isCanada = (account?: Account): boolean => {
    if (!account) {
        account = getAccountFromStore();
    }
    return getRegion(account) === "CA";
};
